module.exports = __webpack_public_path__ + "static/lifestyle3-d5ae5d854e2c9b7b4db177bafab1ac68.jpg";